import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Button, ButtonGroup, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";
import Swal from 'sweetalert2';
import { sanitizarTexto } from "../utils/sanitizarTexto";
import './custom.css';

const PRODUCT_REQUEST_URL =  `${process.env.REACT_APP_API_URL}/product/request`;

const pacienteInicial={
    nombre:"",
    apellido:"",
    email:"",
    documento:"",
    cod_pais:"",
    cod_area:"",
    celular:"",
    errores:{
        cod_area:false,
        celular:false,
        email:false
    }
}
const validarEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

const countries = ["AR", "BR", "CL", "CO", "MX", "US", "ES", "UY", "VE", "BO", "PY"];

export function ProductRequest() {

    const [paciente, setPaciente] = useState(pacienteInicial);
    const [cargando, setCargando] = useState(false);
    const [selected, setSelected] = useState("celular");
    const [selectedCountry, setSelectedCountry] = useState("AR");

    const emailRef = useRef();
    const btnRef = useRef();
    
    const navigate = useNavigate();
    const {state} = useLocation();
    const {producto} = state;
    
    const token = localStorage.getItem("auth")?JSON.parse(localStorage.getItem("auth")).token:null;

    const configProductRequest = {
        method:'post',
        url:PRODUCT_REQUEST_URL,
        //withCredentials:true,
        headers:{ 
            'Content-Type': 'application/json',
            'Authorization': token
        }
    }
    const handleCountryChange = (code) => {
        console.log(code)
        setSelectedCountry(code);
        const countryCodeMap = {
          AR: "54",
          BR: "55",
          CL: "56",
          CO: "57",
          MX: "52",
          US: "1",
          ES: "34",
          UY: "598", 
          VE: "58",  
          BO: "591", 
          PY: "595", 
        };
        const newCode = countryCodeMap[code] || "";
        handleChange({ target: { name: "cod_pais", value: newCode } });
    };

    const validarFormulario = ()=> {
        let _errores = {
            celular:false, 
            cod_area:false,
            cod_pais:false,
            email:false
        }

        if ( (!paciente.celular || paciente.celular.trim()=='' || !paciente.cod_area || paciente.cod_area.trim()==''  || !paciente.cod_pais || paciente.cod_pais.trim()=='' ) 
                && selected=='celular') {
            _errores.celular=true;
            _errores.cod_area=true;
            if(!paciente.cod_pais)
                _errores.cod_pais=true;
        }
        if(paciente.cod_pais==54 && selected=='celular'){
            if(Math.abs(paciente.cod_area).toString().length + Math.abs(paciente.celular).toString().length != 10) {
                _errores.celular=true;
                _errores.cod_area=true;
            }
        }
        if ( !paciente.email && selected=='email') {
            _errores.email=true;
        }

        if (!validarEmail(paciente.email) && selected=='email') {
            _errores.email=true;
        }

        if(_errores.celular || _errores.cod_area || _errores.email){
            setPaciente({...paciente, errores:_errores})
            return false;
        }

        return true;
    }

    const handleChange=(event)=>{
        let _error = {
            celular:false, 
            cod_area:false,
            cod_pais:false,
            email:false
        }
        if(event.target.name=='celular' || event.target.name=='cod_area'  || event.target.name=='cod_pais'){
            let value = event.target.value.replace(/\D/g, '');
            if(event.target.name=='celular'){
                if(Math.abs(paciente.cod_area).toString().length + Math.abs(value).toString().length > 10) {
                    _error.celular=true;
                    _error.cod_area=true;
                }
            }
            else if(event.target.name=='cod_area'){
                if(Math.abs(paciente.celular).toString().length + Math.abs(value).toString().length > 10){
                    _error.celular=true;
                    _error.cod_area=true;
                }
            }

            setPaciente({...paciente, [event.target.name]: value, errores:{...paciente.errores, ..._error}})
        }
        else if(event.target.name=='email'){
            setPaciente({...paciente, [event.target.name]: sanitizarTexto(event.target.value), errores:{...paciente.errores, ..._error}})
        }
        
    }

    const realizarPedido = async ()=>{
        
        btnRef.current.setAttribute("disabled", "disabled");

        if(cargando)
            return;

        if (!validarFormulario()) {
            console.log(paciente.errores)
            let mensajeError='<p>Error en formulario</p>'
            if((!paciente.celular || paciente.celular.trim()=='' || !paciente.cod_area || paciente.cod_area.trim()==''  || !paciente.cod_pais || paciente.cod_pais.trim()=='' ||
                    Math.abs(paciente.cod_area).toString().length + Math.abs(paciente.celular).toString().length != 10 )  
                && selected=='celular') {
                mensajeError='<p>Número de teléfono inválido</p>'
            }

            Swal.fire({
                html: `${mensajeError}`,
                icon: 'error',
                iconColor:'#F08F00',
                confirmButtonText: '<p>OK</p>',
                confirmButtonColor: '#0A9E95'
            })
            btnRef.current.removeAttribute("disabled");
            return;
        }

        setCargando(true);
        const pedido={
            email: (selected == 'email') ? paciente.email : undefined,
            phone: (selected == 'celular') ? paciente.cod_pais + ' ' + +paciente.cod_area.toString() + paciente.celular : undefined,
            lines: [
                {
                    product_id: producto.id,
                    qty: 1
                }
            ]
        }

        try{
            await axios({...configProductRequest, data:pedido})
            Swal.fire({
                html: `<p>Se ha enviado el link al ${selected == 'celular' ? 'celular' : 'email'} indicado</p><p>El mismo será válido por 72 hs.</p>`,
                icon: 'success',
                iconColor:"#0BCF1F",
                confirmButtonText: '<p>Volver</p>',
                confirmButtonColor: '#0A9E95'
            }).then((result) => {
                navigate('/productos');                
            })    
        }
        catch(err){
            setCargando(false);
            console.log(err)
            let msg = '<p>Ocurrió un error al enviar el link</p>';
            if(err && err.response && err.response.data){
                msg = `<p>${err.response.data.message}</p>`
            }            

            Swal.fire({
                html: msg,
                icon: 'error',
                iconColor:'#F08F00',
                confirmButtonText: '<p>Volver</p>',
                confirmButtonColor: '#0A9E95'
            }).then((result) => {
                navigate('/productos');
            })  
        }        
    }

    useEffect(()=>{
        emailRef.current?.focus()
        setPaciente({...paciente, cod_pais:'54'})
    }, [])


    return (
        <>
            <div className="product-request">
                
                <div className="row header-int">
                    <div className="col-md-4 d-none d-md-block">
                        <p></p>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <p className="goback" onClick={()=>navigate(-1)}></p> 
                        <p className="title text-center">{producto.name || ''}</p>
                        <p className="subtitle text-center">{producto.presentation || ''}</p>
                    </div>
                    <div className="col-md-4 d-none d-md-block">
                        <p></p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 d-none d-md-block">
                        <p></p>
                    </div>
                    <div className="col-md-4 d-none d-md-block">
                        <div className="img-frame text-center">
                            <img src={producto?producto.image_full_path:""}/>
                        </div>
                    </div>                  


                    <div className="col-md-4 d-none d-md-block">
                        <p></p>
                    </div>                        
                </div>

                <div className="row">
                    <div className="col-md-4 d-none d-md-block"></div>
                    <div className="col-md-4 col-sm12 body-content mb-0 pb-0">
                        <p className="text-center" style={{fontSize:"1.2rem"}}>Por donde desea enviar la notificación?</p>
                    </div>
                    <div className="col-md-4 d-none d-md-block"></div>
                </div>
                <div className="row">
                    <div className="col-md-4 d-none d-md-block"></div>
                        <div className="col-md-4 col-sm12 body-content mt-0 pt-0">
                            <div className="d-flex">
                                {/* <ButtonGroup  className="d-flex"> */}
                                    <Button
                                        type="button" 
                                        // variant={`${selected === "celular" ? "primary" : ""}`}
                                        className={`${selected === "celular" ? "btn btn-custom" : ""}`}
                                        variant="light"
                                        onClick={() => {
                                            setSelected("celular");
                                            setSelectedCountry('AR');
                                            setPaciente({
                                                ...paciente, 
                                                email:'',
                                                cod_pais:'54',
                                                errores:{email:false, cod_area:false, celular:false}});
                                        }}
                                        style={{ marginRight: "10px" }} 
                                    >
                                        Celular
                                    </Button>
                                    <Button
                                        type="button" 
                                        className={`${selected === "email" ? "btn btn-custom" : ""}`}
                                        variant="light"
                                        onClick={() => {
                                            setSelected("email");
                                            setPaciente({
                                                ...paciente, 
                                                celular:'',
                                                cod_area:'',
                                                cod_pais:'',
                                                errores:{email:false, cod_area:false, celular:false}});
                                        }}
                                    >
                                        Email
                                    </Button>
                                {/* </ButtonGroup> */}
                            </div>
                            <div className="row form-group-lite" style={{marginTop:"50px"}}>

                                
                                
                                { selected=='celular' ?
                                    <>
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-label">Celular *</div> 
                                        </div>
                                    </div>
                                    {/* <div className="row mb-2">
                                        <div className="col-7">
                                            <ReactFlagsSelect
                                                selected={selectedCountry}
                                                onSelect={handleCountryChange}
                                                countries={countries} 
                                                customLabels={{
                                                    AR: "54",
                                                    BR: "55",
                                                    CL: "56",
                                                    CO: "57",
                                                    MX: "52",
                                                    US: "1",
                                                    ES: "34",
                                                    UY: "598", 
                                                    VE: "58",  
                                                    BO: "591", 
                                                    PY: "595", 
                                                }} 
                                                showSelectedLabel={true}
                                                showOptionLabel={true} 
                                                placeholder=" "
                                                searchable={false}
                                                fullWidth={true}
                                                defaultCountry="AR"
                                            />
                                        </div>
                                        <div className="col-5 align-content-end pb-1">
                                            <input name="cod_pais" type="text" className={`form-text bordered ${paciente?.errores?.cod_pais ? ' border-danger' : ''}`} 
                                                onChange={handleChange} value={paciente.cod_pais} maxLength={4} readOnly/>
                                        </div>
                                    </div> */}
                                    <div>

                                    </div>

                                    <div className="row">
                                    <div className="col-4  pl-0 pr-1">
                                            <ReactFlagsSelect
                                                selected={selectedCountry}
                                                onSelect={handleCountryChange}
                                                countries={countries} // Lista personalizada de países
                                                customLabels={{
                                                    AR: "54",
                                                    BR: "55",
                                                    CL: "56",
                                                    CO: "57",
                                                    MX: "52",
                                                    US: "1",
                                                    ES: "34",
                                                    UY: "598", 
                                                    VE: "58",  
                                                    BO: "591", 
                                                    PY: "595", 
                                                }} 
                                                showSelectedLabel={true}
                                                showOptionLabel={true} 
                                                placeholder=" "
                                                searchable={false}
                                                fullWidth={true}
                                                defaultCountry="AR"
                                                className="clase-paises"
                                            />
                                            <p className="text-muted mt-2" style={{fontSize:"0.9rem"}}>Cód. país</p>
                                        </div>
                                        <div className="col-3 pl-1 pr-1">
                                            <input name="cod_area" inputMode="numeric" type="text" className={`form-text bordered ${paciente?.errores?.cod_area ? ' border-danger' : ''}`} 
                                                onChange={handleChange} value={paciente.cod_area} maxLength={5} />
                                            <p className="text-muted mt-2" style={{fontSize:"0.9rem"}}>Cód. area</p>
                                        </div>
                                        <div className="col-5 pl-1 pr-0">
                                            <input name="celular" inputMode="numeric" type="text" className={`form-text bordered ${paciente?.errores?.celular ? ' border-danger' : ''}`} 
                                                onChange={handleChange} value={paciente.celular || ""} maxLength={10-Math.abs(paciente.cod_area).toString().length}/>
                                            <p className="text-muted mt-2" style={{fontSize:"0.9rem"}}>Celular sin el 15</p>
                                        </div>
                                    </div>
                                    </>
                                :
                                    <>
                                        <p className="label"><span className="label-text">Email *</span></p> 
                                        <p className="mt-18">
                                            <input  ref={emailRef} className={`form-text bordered ${paciente?.errores?.email ? ' border-danger' : ''}`}  
                                                type="text" name ="email" onChange={handleChange} value={paciente.email || ""} maxLength={50}/>
                                        </p>
                                    </>
                                }


                            </div>
                            <div>
                                <Button ref={btnRef} type="button" variant="primary" onClick={realizarPedido}>
                                    { !cargando ? ( selected=='celular' ? "Enviar whatsapp" : "Enviar email" ): "Enviando..." }
                                </Button>
                            </div>
                            {/* <Button type="button" variant="primary" onClick={()=>{navigate('/pedido/status')}}>STATUS
                            </Button> */}
                        </div>
                    <div className="col-md-4 d-none d-md-block"></div>
                </div>
            </div>
        </>
    )
}
